import React, { useState, useMemo, useEffect } from 'react';
import { Typography, Card, Grid } from "@mui/material";
import Box from '@mui/material/Box';
import { useSelector } from "react-redux";
import getSetDataService from "../../../../shared/common-utilities/services/getSetDataService";
import DataGridComponent from '../../common/DataGridComponent/DataGridComponent';
import Spinner2 from "../../common/Spinner/Spinner2";
import commonApiService from '../../../../shared/common-utilities/services/commonApiService.jsx';
import _ from 'lodash';
import { getRoutes,getPartialTrip,fetchSavedView  } from '../../../../shared/common-utilities/services/commonUrlConsts/commonUrlConsts';
import ModalComponent from '../../common/Modal/ModalComponent';
import AlertComponent from '../../../../shared/common-utilities/common/AlertComponent.jsx';
import dataStorageService from '../../../../shared/common-utilities/services/DataStorageService.jsx';

const entity = "route";
const odataApiName = "routes";
const odataApiNameFor = "routes"; // Future use if need to open as popup from any plan function
let service = getSetDataService();
let apiService = commonApiService();
let storageService = dataStorageService();
let dataRelatedAction = ['Filter', 'View Columns', 'Settings', 'Refresh', 'New Window'];
const planRelatedAction = ['Move Up', 'Move Down', 'Change Route', 'Change Status', 'Set Free'];

const TripRoutes = (prop) => {

  const routeGriddDtaItemKey = "id";
  const initialSort = service.initialSort[entity];
  const routeGridRefreshReducerData = useSelector(state => state?.tripRoutes?.isRefreshRouteGridData);

  //#region Reference
  const routeGrid = React.useRef(null);
  let gridSelectedValues = {};
  //#endregion Reference

  //#region Hook Selctor
  const partialTripReducerData = useSelector(state => state.partialTrip);
  //#endregion Hook Selctor

  //#region States - Get set variables  

  const [tempTripRouteMovementsData, setTempTripRouteMovementsData] = useState([]);
  const [routeGridColumnList, setRouteGridColumnList] = React.useState(null);
  const [tempRouteGridColumnList, setTempRouteGridColumnList] = useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [loadedGridData, setLoadedGridData] = useState(tempTripRouteMovementsData);
  const [myGridData, setmyGridData] = React.useState([]);
  const [loadSelectionValue, setloadSelectionValue] = useState(100);
  const [totalData, setTotalData] = useState();
  const userID = localStorage.getItem('userID');
  const startDate = new Date();
  const days = 30;

  const [isRoutes, setIsRoutes] = useState(true);

  const [isApiLoaded, setIsApiLoaded] = useState(false);
  const [paramsData, setParamsData] = useState(null);
  let [initialFilter, setInitialFilter] = useState([]);
  const [isSuccessSnackbarOpen, setSuccessSnackbarOpen] = useState(false);
  const [successSnackbarMessage, setSuccessSnackbarMessage] = useState('');
  const [isErrorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
  const [errorSnackbarMessage, setErrorSnackbarMessage] = useState('');
  const routeFilterComponents = [
    { type: 'DatePicker', key: 'startingDate', value: startDate, label: 'Start date', placeholder: 'Start date...' },
    { type: 'NumericTextBox', key: 'daysToShow', value: days, label: 'Days to Show', placeholder: 'Please enter value', relationalField: 'startingDate' },
  ];
  const [tripId, setTripId] = useState(null);
  const [nextDataUrl, setNextDataUrl] = useState(null);
  const [initialSaveViewData, setInitialSaveViewData] = useState([]);
  const [initialFetchReadLinkData, setInitialFetchReadLinkData] = useState(null);
  const [changeToChildTR, setChangeToChildTR] = useState(null);
  const [isApiCallRequired, setIsApiCallRequired] = useState(true);
  const [openConfirmationModal, setopenConfirmationModal] = useState(false);
  const [commonPopupParameters, setCommonPopupParameters] = React.useState({});
  const [errorMessage, setErrorMessage] = useState(null);
  const [isRemovePreAndSelection, setIsRemovePreAndSelection] = useState(false);
  const [canExecute, setCanExecute] = useState([]);
  const [openResModal, setOpenResModal] = useState(false);
  const [isMultipleData,setIsMultipleData] = useState(false)
  const metaData = JSON.parse(storageService.getLocalStorageData("metaData"))

  //#endregion States


  //#region Hooks  
  useEffect(() => {
    // setIsLoading(true);

    setIsApiLoaded(true);
    setTimeout(()=>{
      setGridColumns(entity);
    },100)

    let tempFilterData = [];
    if (days > 0) {
      tempFilterData.push({ field: 'startingDate', value: service.dateFormat(startDate, 'startDate') + (days > 0 ? ".." + service.dateFormat(startDate, 'startDate', days) : ""), isLast: false, type: 'Edm.Date' });
    } else {
      tempFilterData.push({ field: 'startingDate', value: ">=" + service.dateFormat(startDate, 'startDate'), isLast: false, type: 'Edm.Date' });
    }

    setInitialFilter(tempFilterData);
    dataRelatedAction = prop?.isChild ? dataRelatedAction.filter(e => e != 'Filter') : dataRelatedAction;
  }, []);

  useEffect(() => {
    if (tripId != null && !_.isNil(paramsData) && (prop.guid == partialTripReducerData.guid)) {
      sendApiForRoute();
    }
  }, [tripId,partialTripReducerData.isRefreshRouteAndPT]);

  useEffect(()=>{
    if(!_.isNil(partialTripReducerData)  && (prop.guid == partialTripReducerData.guid)) {
      setIsMultipleData(partialTripReducerData.isMultiplePT)
    }
  },[partialTripReducerData.isMultiplePT])

  const setGridColumns = (entityName) => {
    const columnList = localStorage.getItem(entityName + 'ColumnList');
    if (!_.isNil(columnList)) {
      setRouteGridColumnList(JSON.parse(columnList));
      getColList(entity, JSON.parse(columnList));
      return true;
    }

    if(!_.isNil(metaData) || metaData !== "undefined") {
      service.entityDefinitions(metaData,entityName).then((tempFieldList)=>{
        localStorage.setItem(entityName + 'ColumnList', JSON.stringify(tempFieldList));
        setRouteGridColumnList(tempFieldList);
        getColList(entity, tempFieldList);
      })
    }
  }

  const getDefaultColList = (dcolsString, entityName, gridcolumns) => {
    if (!_.isNil(dcolsString) && dcolsString != "undefined") {
      const dCols = JSON.parse(localStorage.getItem("defaultColumnSetting"));
      const defaultColumnList = gridcolumns?.filter(item => {
        return dCols[entity]?.split("~").includes(item.field);
      });
      if (defaultColumnList.length == 0) {
        localStorage.setItem(entityName + 'TempColumnList', JSON.stringify(gridcolumns));
        setTempRouteGridColumnList(gridcolumns);
      } else {
        const sortedArr = _.sortBy(defaultColumnList, function (item) { return dCols[entity]?.split("~").indexOf(item.field) });
        localStorage.setItem(entityName + 'TempColumnList', JSON.stringify(sortedArr));
        setTempRouteGridColumnList(sortedArr);

        const arr1 = sortedArr;
        const arr2 = gridcolumns.filter(e => !sortedArr.map(x => x.field).includes(e.field));
        const newsortedArr = _.concat(arr1, arr2);
        setRouteGridColumnList(newsortedArr);
      }
    } else {
      localStorage.setItem(entityName + 'TempColumnList', JSON.stringify(gridcolumns));
      setTempRouteGridColumnList(gridcolumns)
    }
  }

  const getColList = (entityName,gridcolumns) => {
    const url = `${fetchSavedView}?$filter=(title eq '${odataApiName}' and userID eq '${userID}')`
    const dcolsString = localStorage.getItem("defaultColumnSetting");
    apiService.get(url).then(savedViewRes => {
      if (savedViewRes?.value?.length > 0) {
        apiService.get(savedViewRes.value[0]["userMetadata@odata.mediaReadLink"], savedViewRes.value[0]["@odata.etag"]).then(readRes => {
          if (readRes !== undefined && readRes !== null) {
            setInitialSaveViewData(savedViewRes.value);
            setInitialFetchReadLinkData(readRes);
            const defaultViewExist = readRes[odataApiName]?.savedViews?.filter(item => item.defaultView);
            if (defaultViewExist?.length > 0 && defaultViewExist[0] !== undefined && defaultViewExist?.[0]?.columns) {
              setCanExecute(defaultViewExist);
              setTempRouteGridColumnList(defaultViewExist[0].columns);
            } else if (readRes[odataApiName].columns?.length !== 0) {
              localStorage.setItem(entityName + 'TempColumnList', JSON.stringify(readRes[odataApiName].columns))
              setTempRouteGridColumnList(readRes[odataApiName].columns);
            } else {
              getDefaultColList(dcolsString, entityName, gridcolumns);
            }
          }
        })
      } else {
        getDefaultColList(dcolsString, entityName, gridcolumns);
      }

      setIsLoading(false);
    });
  }

  useEffect(() => {
    if (!_.isNil(partialTripReducerData)  && (prop.guid == partialTripReducerData.guid)) {
      setTripId(partialTripReducerData.tripNumber);
    }
  }, [partialTripReducerData])

  useEffect((e) => {
    if (!_.isNil(paramsData) && isApiCallRequired) {
      if (prop.isChild) {
        sendApiForRoute();
      } else {
        updateSendApi(loadSelectionValue);
      }
    } else {
      setIsApiCallRequired(true);
    }
  }, [paramsData]);

  useEffect(() => {
    if (prop.isPin !== undefined && prop.isPin !== null) {
      setIsRoutes(prop.isPin);
    }
  }, [prop.isPin])

  useEffect(() => {
    if (routeGridRefreshReducerData) {
      setNextDataUrl(null);
      setParamsData({ ...paramsData });
    }
  }, [routeGridRefreshReducerData])

  useEffect((e) => {
    if (!_.isNil(tempRouteGridColumnList)) {
      if (prop.isChild) {
        sendApiForRoute();
      } else {
        setNextDataUrl(null)
        setIsApiCallRequired(true);
      }
    }
  }, [tempRouteGridColumnList]);

  //#endregion Hooks

  const sendApi = (val, size) => {
    let filter = paramsData?.filter ? '$filter=(' + paramsData?.filter + ')' : null;
    let orderby = paramsData?.orderby ? '$orderby=' + paramsData?.orderby : null;
    if (canExecute?.length > 0) {
      return;
    }
    if (tempRouteGridColumnList !== null && tempRouteGridColumnList !== undefined && tempRouteGridColumnList?.length > 0 && !prop.isChild && !prop?.customView) {
      setIsLoading(true);
      const params = '&' + filter + '&' + orderby + '&$count=true';
      const columns = tempRouteGridColumnList?.map(item => item.field);
      const mandatroyEntity = JSON.parse(localStorage.mandatoryColumnList).find(e => e.entity == odataApiName)
      if (!_.isNull(mandatroyEntity)) {
        let splitedColums = mandatroyEntity.mandatoryColumns.split("~")
        splitedColums.forEach(element => {
          if (!columns.includes(element)) {
            columns.push(element)
          }
        });
      }

      const selectFields = `&$select=${columns}`;
      const oDataNextLink = val == 'Scroll' ? nextDataUrl : null;
      apiService.get(getRoutes,params, `${selectFields}`, oDataNextLink, size,null).then(response => {
        if (response !== null && response !== undefined && response.error !== null && response.error !== undefined && response.error) {
          setErrorParameterAndMessage(response?.error?.message.split('CorrelationId')[0]);
          if (response?.error?.message?.includes('$orderby')) {
            const sortToRemoveTR = response.error.message.split("'")[1];
            setChangeToChildTR({ type: "sort", value: sortToRemoveTR });
          } else if (response?.error?.code == "Application_FilterErrorException") {
            const filterToRemoveTR = response.error.message.split("'")[1];
            setChangeToChildTR({ type: "filter", value: filterToRemoveTR });
          }
        } else {
          if (response.value) {
            setTotalData(response["@odata.count"])
            let tempData = [];
            if (val == 'Scroll' && tempTripRouteMovementsData !== null && tempTripRouteMovementsData !== undefined && tempTripRouteMovementsData.length > 0) {
              tempTripRouteMovementsData.forEach(tempRoutes => {
                tempData.push(tempRoutes);
              });
              response.value.map(temp => {
                tempData.push(temp)
              })
            }
            // Update the data based on the response
            else {
              tempData = response.value;
            }
  
            setIsApiLoaded(true);
            if (response['@odata.nextLink'] !== null && response['@odata.nextLink'] !== undefined) {
              setNextDataUrl(response['@odata.nextLink']);
            }
  
            tempData = service.setColorCodeAndDate(tempData, routeGridColumnList);
  
            setmyGridData(tempData);
            setLoadedGridData(tempData);
            setTempTripRouteMovementsData(tempData);
          }
        }
      })
        .catch(error => {
          console.error('API error:', error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  }

  const updateSendApi = useMemo(() => {
    return _.debounce((size) => {
      sendApi(null, size);
    }, 250);
  }, [sendApi]);

  const sendApiForRoute = (isRemovePreAndSelection = true) => {
    if (_.isNil(tripId) || tripId == "" ) {
      setTotalData(0);
      setmyGridData([]);
      setLoadedGridData([]);
      setTempTripRouteMovementsData([]);
      return;
    }
    let filter = "$filter=(id eq " + tripId + ")";
    let orderby = paramsData?.orderby ? '$orderby=' + paramsData?.orderby : null;
    const params = '&' + filter + '&$count=true';
    let expands = '&$expand=routes';
    if (orderby !== null && orderby !== undefined) {
      expands += '(' + orderby + ')';
    }

    if(!prop?.customView) {
      setIsLoading(true);
      apiService.get(getPartialTrip,null,`${params}${expands}`,null,null,null).then(response => {
        if (response.value !== null && response.value !== undefined && response.value.length > 0) {
          setTotalData(response.value[0].routes?.length);
          const tempData = service.setColorCodeAndDate(response.value[0].routes,tempRouteGridColumnList);
          setmyGridData(tempData);
          setLoadedGridData(tempData);
          setTempTripRouteMovementsData(tempData);
          setIsRemovePreAndSelection(isRemovePreAndSelection);
        } else if (response.value !== null && response.value !== undefined && response.value.length === 0) {
          setTotalData(0);
          setmyGridData([]);
          setLoadedGridData([]);
          setTempTripRouteMovementsData([]);
        } else {
          // Error Handling code here
          console.error("Response value is not available.");
        }
      })
        .catch(error => {
          console.error('API error:', error);
        })
        .finally(() => {
          setIsLoading(false);
        })
    }
  }

  // --- Common methods END ---
  //#endregion Methods

  //#region Not in use

  const childStateHandler = (value, flag, isRemovePreAndSelection = true) => {
    if (flag === 'showGridHeader') {
      setIsRoutes(value);
    } else if (flag === 'getData') {
      setNextDataUrl(null);
      setParamsData({ ...paramsData, filter: value.filter, orderby: value.orderby });
      setIsApiCallRequired(value.isApiCall);
      setTempRouteGridColumnList(value.columns);
      setCanExecute([]);
    } else if (flag === 'refresh') {
      if (prop.isChild) {
        sendApiForRoute();
      } else {
        sendApi(null, loadSelectionValue);
      }
    } else if (flag === 'selectedValues') {
      gridSelectedValues = value;
    } else if (flag === 'sendApiForRoute') {
      if (prop.isChild) {
        sendApiForRoute(isRemovePreAndSelection);
      }
    } else if (flag === 'columnsVisible') {
      setTempRouteGridColumnList(value);
    } else if (flag === 'openResModal') {
      setOpenResModal(value);
    }
  }

  const onLoadSelectionChange = (e) => {
    if (prop.isChild) {
      sendApiForRoute();
    } else {
      let value = e.value;
      setloadSelectionValue(value);
      sendApi(null, value);
    }
  }

  const handleSuccessSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSuccessSnackbarOpen(false);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setErrorSnackbarOpen(false);
  };

  const setErrorParameterAndMessage = (errMsg) => {
    setCommonPopupParameters({
      title: 'Error'
    });
    setErrorMessage(errMsg);
    setopenConfirmationModal(true);
  }

  const closeConfirmationModal = () => {
    setopenConfirmationModal(false);
  }

  const onGridClick = () => {
    if (window.location.hash.includes("#/CustomView") && storageService.getLocalStorageData('currentActive') !== odataApiName && !openResModal){
      storageService.setLocalStorageData('currentActive', odataApiName);
    }
  }

  //#endregion

  return (
    <>
      {isLoading ? (<Spinner2 styisAll={loadSelectionValue} />) : (<></>)}
      <Grid item xs={12} component={Card} elevation={0} square pl={0} sx={{ position:'relative', p: 1, width: '100%' }} onClick={onGridClick}>

        {isRoutes &&
          <Box className="headBG" sx={{ px: 1, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography variant="body2" color="secondary.contrastText" sx={{ fontWeight: 500 }}>Routes</Typography>
          </Box>
        }
        <Box sx={{ p: 0, display: 'flex' }} className="filterbar-bg ">
          <Grid
            item={true}
            elevation={0}
            pl={0}
            sx={{ flexGrow: 1, }}
            className='grid-movement'
            xs component={Card}
          >
            {
              isApiLoaded &&
              <DataGridComponent
                {...prop}
                gridRef={routeGrid}
                gridFlagVal={odataApiName}
                gridFlagValFor={odataApiNameFor}
                gridStyle={{ maxHeight: 'calc(100%)', height: '100%', minHeight: '650px' }}
                entity={entity}
                gridNewData={isMultipleData ? [] : myGridData}
                loadedGridData={isMultipleData ? [] : loadedGridData}
                tempGridData={isMultipleData ? [] : tempTripRouteMovementsData}
                gridColumnList={routeGridColumnList ? routeGridColumnList : []}
                gridTempColumnList={tempRouteGridColumnList ? tempRouteGridColumnList : []}
                gridSort={initialSort}
                isItemVisible={true}
                gridInitialFilter={initialFilter}
                isShowGridHeader={isRoutes}
                griddDtaItemKey={routeGriddDtaItemKey}
                sendDataToParent={childStateHandler}
                gridDataAction={dataRelatedAction}
                gridPlanAction={planRelatedAction}
                gridFilterComponents={routeFilterComponents}
                onLoadSelectionChange={onLoadSelectionChange}
                loadSelectionValue={loadSelectionValue}
                gridtotalData={isMultipleData ? 0 : totalData}
                initialSaveViewData={initialSaveViewData}
                initialFetchReadLinkData={initialFetchReadLinkData}
                changeToChild={changeToChildTR}
                isRemovePreAndSelection={isRemovePreAndSelection}
                isDraggable={true}
              />
            }
          </Grid>
        </Box>
      </Grid>
      <AlertComponent isSuccessSnackbarOpen={isSuccessSnackbarOpen} successSnackbarMessage={successSnackbarMessage} handleSuccessSnackbarClose={handleSuccessSnackbarClose}
        isErrorSnackbarOpen={isErrorSnackbarOpen} errorSnackbarMessage={errorSnackbarMessage} handleErrorSnackbarClose={handleErrorSnackbarClose}
      ></AlertComponent>
      <ModalComponent message={errorMessage} params={commonPopupParameters} openConfirmationModal={openConfirmationModal} closeConfirmationModal={closeConfirmationModal} />
    </>
  )
}

export default TripRoutes;